import React from 'react';

import { connect } from 'react-redux';

import { Box } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';

// @ts-ignore - ignore error
import type { Calculator, FieldName } from '../types';
import {
  getMaxByCalculator,
  getFieldPlaceholderByCalculator,
  getFieldValueByCalculator,
} from '../utils';

// @ts-ignore - ignore error
import styles from './bar-chart.module.less';

interface BarChartProps {
  fieldName: FieldName;
  calculator: Calculator;
}

interface OwnProps {
  value: number;
  max: number;
}

const BarChart = (props: OwnProps): JSX.Element => {
  const { value, max } = props;
  const barWidth = (num.value(value) / num.value(max)) * 100;

  return (
    <Box
      className={styles.barChart}
      width={100}
      backgroundColor="neutral-light"
    >
      <Box
        className={styles.barChart}
        backgroundColor="blue"
        style={{ width: `${barWidth}%` }}
      />
    </Box>
  );
};

const mapStateToProps = (state, ownProps: BarChartProps) => {
  const { fieldName, calculator } = ownProps;
  return {
    value:
      getFieldValueByCalculator(state, calculator, fieldName) ??
      getFieldPlaceholderByCalculator(state, calculator, fieldName) ??
      0,
    max: getMaxByCalculator(state, calculator),
  };
};

export default connect(mapStateToProps)(BarChart);
